<template>
  <!-- TODO: 参考https://h5.lanhushipin.cn/html/fuwu.html  调整内容 -->
  <div class="user-agreement">
    <h1>《“搜机网”会员服务协议》</h1>
    <p>更新日期：2025年02月11日</p>
    <p>生效日期：2025年02月11日</p>
    <p>欢迎您使用“搜机网”付费会员服务！</p>
    <p>本“搜机网”会员服务（以下简称“本服务”）是由北京泽雨昌盛科技有限公司和/或其关联方（以下简称“公司”或“我们”）为您提供。</p>
    <p>
      本服务为付费服务。为使用本服务，您应当阅读并遵守《“搜机网”会员服务协议》（以下简称“本协议”）、《“搜机网”用户协议》、《“搜机网”隐私政策》、《“搜机网”创作者协议》等协议及规则（以下统称“服务协议及规则”）。您在申请开通本服务并进入购买程序前，请您务必审慎阅读、充分理解各服务协议及规则，特别是免除或限制责任条款、法律适用和争议解决条款以及购买或使用某项服务的单独协议和/或规则。
    </p>
    <p>如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称“监护人”）的陪同下阅读并判断是否同意本协议，并特别注意服务协议及规则中的未成年人使用条款。</p>
    <p>如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。</p>
    <p>如果您不同意本协议或其中任何条款约定，请您立即停止开通程序。当您按照本服务开通页面提示阅读并同意本协议且完成全部开通程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与本服务提供方达成一致，成为“搜机网”创作者会员。
    </p>
    <p>一、定义及适用范围</p>
    <p>1.1
      本协议是您与公司之间就您注册、登录之后或在游客模式下使用本服务所订立的协议。您点击“同意”或“下一步”或“确认支付”等确认按钮，或您使用本服务，或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意签署本协议。本协议即在您与公司之间产生法律效力，成为对双方均具有约束力的法律文件。
    </p>
    <p>1.2
      “搜机网”创作者会员：指已按照服务协议及规则完成“搜机网”注册、登录的用户，在签署本协议并根据本服务开通页面所展示的收费标准支付相应费用后获取的特殊资格（公司根据业务发展可能会调整会员名称，实际名称以本服务开通页面展示为准，不影响您的实际权益）。在本协议或简称为“创作者会员”或“您”。
    </p>
    <p>1.3
      “搜机网”创作者会员权益：指用户基于其“搜机网”创作者会员资格所享有的特殊权益，具体权益内容应以本服务购买时页面展示内容为准，该等创作者会员权益将在本服务购买时页面进行展示、不定期更新，请予以关注。本协议中或简称为“创作者会员权益”。
    </p>
    <p>1.4
      会员有效期：会员服务购买页面及其它相关页面中所展示的“一个月”指您付费开通本服务之日起，可以享有创作者会员权益30天；“一年”指您付费开通本服务之日起，可以享有创作者会员权益365天；“两年”指您付费开通本服务之日起，可以享有创作者会员权益730天；服务有效期与“搜机网”存续期相关联。
    </p>
    <p>1.5 本协议内容同时包括公司已经发布及后续可能不断发布的关于本服务的相关协议、规则等内容。前述内容一经正式发布，并以适当的方式送达您（服务购买页面、网站公布、系统通知等），即为本协议不可分割的组成部分，您应同样遵守。</p>
    <p>二、服务开通、权益内容、服务期限及收费标准</p>
    <p>2.1 本服务的开通仅支持“搜机网”注册登录用户开通。您应确保在本服务开通及使用过程中，始终具备完全民事权利能力和完全民事行为能力，并确保您具有签订和履行本协议项下权利义务之实际能力。</p>
    <p>2.2
      您可通过各种已有和未来新增的支付渠道或公司指定的方式完成本服务的购买进而成为“搜机网”创作者会员。当您根据本服务页面提示确认并成功支付了会员服务费和/或完成了成为“搜机网”创作者会员的所有程序，且通过公司审核后，您可享受本服务。
    </p>
    <p>2.3
      “搜机网”创作者会员权益为可发布创作者素材。为了改善用户体验、完善服务内容，公司可能会对“搜机网”会员及/或其相关服务、权益、功能、界面等进行更新、修改，包括开发新功能／权益、删除旧功能／权益等，具体应以本服务开通页面展示的权益为准。您可按照变更后的本服务的实际情况继续使用相应权益、功能或服务并适用本协议的相关约定。
    </p>
    <p>2.4 本服务的服务期限以您自行选择并支付的会员费用所对应的期限为准。在“搜机网”存续期间内，服务期限届满后，公司将停止继续向您提供本服务。</p>
    <p>2.5
      您申请开通本服务时，需根据页面提示支付相应的服务费用后方可完成开通。基于权益调整、市场与业务的发展，公司可能会调整本服务开通所需服务费用。本服务的服务费用调整自公布之日起生效，您于生效前已开通的本服务不受影响，但该服务到期后若需续费开通，则需按照调整后已生效的费用标准支付。
    </p>
    <p>2.6 价格说明</p>
    <p>(1)
      划线价格：付费服务的划横线价格为服务提供商制定的市场参考价、指导价或该付费服务曾经展示过的销售价等。由于地区、时间的差异性和市场行情波动，付费服务的参考价、指导价等可能与您实际购买/消费时的展示销售价不一致，该划横线价格仅供您参考。
    </p>
    <p>(2) 未划线价格：付费服务的未划线价格为展示销售价、实时标价，不因表述的差异改变性质。具体成交价格可能根据付费方式的差异、汇率原因或用户使用优惠券、积分等情况发生变化，您购买付费服务的实际价格应以订单结算页价格为准。</p>
    <p>(3) 活动促销价/折扣价：如无特殊说明，活动促销价/折扣价是服务提供商在划线价格、参考价、指导价基础上给予的优惠价格。如有疑问，您可以在购买前与客服联系。</p>
    <p>(4) 价格异常：因可能存在系统缓存、页面更新延迟等不确定性情况，导致价格显示异常，付费服务的实际价格请以订单结算页价格为准。如您发现异常情况出现，请立即通过页面的“联系客服”或者到“我的-&gt;意见反馈“
      联系我们补正，以便您能顺利完成付费服务的购买。</p>
    <p>2.7 公司仅提供相关的云服务，除此之外与相关云服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由您自行负担。</p>
    <p>2.9 自您成功开通本服务之日起，您可在登录“搜机网”帐号后在“我的-&gt;创作者会员“页面查询您的会员信息，包括但不限于已开通权限、服务期限、会员类型等。</p>
    <p>2.10 由于本服务创作者会员权益为虚拟内容消费，除法律法规另有规定外，支付完成后，不可进行转让和退款。</p>
    <p>三、服务使用</p>
    <p>3.1
      本服务、创作者会员权益仅限您本人使用。未经公司书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该帐号及帐号项下的所有会员服务/所有会员权益。如果公司发现或者有合理理由认为使用者并非帐号初始注册人，为保障帐号安全，公司有权立即暂停或终止向该注册帐号提供本协议约定服务。您应正确使用及妥善保管、维护您的帐号及密码，如发生泄漏、遗失、被盗等行为，而该等行为并非公司过错导致，损失将由您自行承担。
    </p>
    <p>3.2
      如您存在如下违法/不当使用本服务的情形，公司有权取消您的所有会员资格、作废所有会员权益且您不应要求公司退还您所支付的所有会员服务费用。您应对您不当使用所用会员服务的行为及后果（包括损失）负责，您若给公司造成损失的，公司有权向您追偿：
    </p>
    <p>
      （1）以盗窃、利用系统漏洞（包括但不限于机器人软件、蜘蛛软件、爬虫软件、刷屏软件等）、通过任何非公司官方或授权渠道、途径、方式获得的本服务（包括但不限于购买、租用、借用、分享、受让等方式获得）、恶意利用或破坏本服务相关活动获得的所有会员服务的行为；
    </p>
    <p>（2）利用本服务进行盈利或非法获利，以各种形式转让或转移您所享有的本服务、创作者会员权益，或将本服务、会员权益借给他人使用；</p>
    <p>（3）通过非法手段对本服务会员账户的服务期限、消费金额、交易状态进行修改，或用非法的方式或为了非法的目的使用已购买的本服务；</p>
    <p>（4）主动对公司用于保护本服务创作者会员权益的任何安全措施技术进行破解、更改、反操作、破坏或其他篡改，或协助他人进行上述行为；</p>
    <p>（5）您参加创作者会员活动时，应按照活动规则、以合法且不损害活动举办方利益的方式进行，利用系统漏洞、规则设置缺陷、系统设置错误、滥用会员身份等参加活动并获取相关福利的，均不受保护；</p>
    <p>（6）使用本服务获取的权益并非用于个人消费或使用的；</p>
    <p>（7）其他违反法律法规、诚实信用原则、服务协议及规则的行为。</p>
    <p>3.3
      如您通过任何不正当手段或以违反诚实信用原则的方式开通本服务的（如恶意绕过正常开通流程），公司有权拒绝您的开通申请、终止已开通的本服务、已绑定或获取的创作者会员权益被全部/部分取消或暂停使用，且您不应要求退还已支付的会员服务费用（如有）。
    </p>
    <p>3.4 您知悉并同意，为保证您充分享受本服务、避免您错过优质会员权益，公司可能通过消息、通知、短信等形式，向您提供会员权益相关信息。</p>
    <p>四、知识产权</p>
    <p>4.1
      如您使用““搜机网”“软件的某个功能进行视频创作，您不得将软件提供的任何内容素材设计到任何商标之中，也不得将软件提供的任何内容与任何徽标、公司名称、图形商标、服务商标或其他来源的商标相关联，您自己有版权并以此版权定制的内容除外。
    </p>
    <p>4.2
      未经公司和/或相关权利人的授权许可，任何人不得擅自将本服务项下的产品/服务/资料/内容等用于任何商业或非商业目的；不得对本服务项下的产品/服务/资料/内容等进行包括（但不限于）反向工程、反编译、反汇编等可能影响或改变其原有内容或功能的行为，不得破解或试图破解前述产品/服务/资料/内容等相关的安全和保密措施，不得对本服务项下的产品/服务/资料/内容等资源进行扒取、存储、缓存、下载、镜像等，且不得利用本服务项下的产品/服务/资料/内容等开发同类产品、服务，也不得协助或允许任何第三方进行上述行为，否则由此给公司和/或其他权利人造成的损失或损害均应由您全权承担。
    </p>
    <p>4.3
      未经公司和/或相关权利人的授权许可，任何用户和第三方不得以获取直接或间接经济利益为目的，采用收费或免费的方式，复制、编辑、翻拍、翻制、修改、转载、出版、汇编、发表、引用、传播本服务项下的任何信息内容，包括“口播学院”的各类教学视频、图文讲解和“爆款拆解”。
    </p>
    <p>4.4
      如因用户将本服务项下的信息内容部分或者全部公开展示、搬运、进行商业性、盈利性等使用进而造成违约传播等，进而侵害其他权利人和/或公司的权利时，公司有权立即暂停相关用户的访问权、使用权以及其他基于本协议所获得的权益；同时有权针对由相关用户前述行为所导致的损失要求相关用户承担赔偿责任；公司保留追究知识产权侵权、违约传播等行为人的法律责任的权利。
    </p>
    <p>五、服务中止、终止及变更</p>
    <p>5.1 本服务的中止或终止包含如下情况：</p>
    <p>（1）您主动中止或终止，包括但不限于会员到期未进行续费等；</p>
    <p>（2）因为您的违约行为，公司主动中止或终止服务的；</p>
    <p>（3）因国家或相关政府监管部门要求或发生不可抗力事件时，公司中止或终止服务的；</p>
    <p>（4）其他根据法律法规应中止或终止服务的。</p>
    <p>5.2
      您知悉并确认，您开通本服务后，如您在服务未期满时主动取消本服务、放弃创作者会员权益、或终止资格，或公司根据法律法规、本协议或其他服务协议及规则注销您的帐号、终止您的创作者会员的，您不应要求退还部分或全部创作者会员服务费用。
    </p>
    <p>5.3
      本协议终止后，用户无权要求公司继续向其提供任何服务或履行任何其他义务。本协议的终止并不影响终止前您与公司基于本协议产生的权利义务。因您的原因导致公司遭受第三方索赔、行政部门处罚等，您应当赔偿公司因此产生的损失及（或）发生的费用。
    </p>
    <p>5.4
      由于互联网高速发展，您与公司签署的本协议列明的条款并不能完整罗列和涵盖您与公司之间就本协议约定服务的所有权利与义务，现有的约定也不能完全保证符合未来发展的需求。公司可根据国家法律法规变化、业务实际变更需求、保护用户权益的需要等，不时修改本协议，并按照法律法规规定的程序及方式进行公告。如用户不同意变更后的内容则用户有权主动停止使用本服务，如用户在变更内容生效后仍继续使用本服务即视为用户同意该等内容变更。
    </p>
    <p>六、责任限制</p>
    <p>6.1
      您理解并同意，公司提供的本服务是按照现有技术和条件所能达到的现状提供的。公司会尽最大努力向您提供服务，确保服务的连贯性和安全性。您理解，公司不能随时预见和防范技术以及其他风险，包括但不限于不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用本软件及服务以及其他的损失和风险。
    </p>
    <p>6.2 基于收益与赔偿相一致及公平合理的原则，如因公司原因造成本服务不正常中断或服务不可用，您所可能获得的最高赔偿额不超过本协议项下公司已实际收取的相关服务费用总额。</p>
    <p>七、未成年人使用的特别约定</p>
    <p>7.1 若您是未满18周岁的未成年人，您应在监护人监护、指导并获得监护人同意情况下认真阅读本协议和使用本服务。</p>
    <p>7.2 未成年用户应理解如因您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担由此可能引发的全部法律责任及后果。</p>
    <p>7.3 未成年人用户特别提示：</p>
    <p>（1）青少年使用本服务应该在监护人的监督、指导下，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好上网习惯。</p>
    <p>（2）青少年用户必须遵守《全国青少年网络文明公约》：</p>
    <p>a. 要善于网上学习，不浏览不良信息；</p>
    <p>b. 要诚实友好交流，不侮辱欺诈他人；</p>
    <p>c. 要增强自护意识，不随意约会网友；</p>
    <p>d. 要维护网络安全，不破坏网络秩序；</p>
    <p>e. 要有益身心健康，不沉溺虚拟时空。</p>
    <p>7.4 监护人特别提示</p>
    <p>（1）如您的被监护人使用“搜机网”及本服务的，您作为监护人应指导并监督被监护人的注册和使用行为，如您的被监护人申请注册“搜机网”帐号，公司将有权认为其已取得您的同意。</p>
    <p>（2）您的被监护人在使用“搜机网”及本服务时可能使用付费功能。您作为监护人，请保管好您的支付设备、支付账户及支付密码等，以避免被监护人在未取得您同意的情况下通过您的“搜机网”帐号使用付费功能。</p>
    <p>八、其他</p>
    <p>8.1 本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</p>
    <p>8.2
      本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国法律。若本协议之任何规定因与中华人民共和国的法律抵触而无效或不可执行，则这些条款将尽可能按照接近本协议原条文意旨重新解析，且本协议其它规定仍应具有完整的效力及效果。
    </p>
    <p>8.3 本协议的签订地为中华人民共和国北京市门头沟区。若你因本协议与公司发生任何争议，双方应尽量友好协商解决；如协商不成的，你同意应将相关争议提交至本协议签订地的人民法院诉讼解决。</p>
    <p>8.4 本协议与其他服务协议及规则就同一事项有冲突约定的，应以本协议约定为准；本协议未尽事宜应以其他服务协议及规则为准，其他服务协议及规则亦无约定的，应由您与公司另行达成约定。</p>
    <p>8.5 如您在使用本服务过程中有任何疑问、意见或建议，请通过“搜机网”-&gt;“我的 -&gt;客服或意见反馈“进行意见反馈或发送邮件至kefu@souji168.cn联系我们进行反馈。</p>
    <p>8.6 本协议的版权为北京泽雨昌盛科技有限公司所有，公司保留一切解释和修改的权利。</p>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement'
}
</script>

<style scoped>
.user-agreement {
  width: 98%;
  margin: 0 auto;
  padding: 1%;
  font-size: 14px;
  line-height: 1.6;
  text-indent: 32px;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
  text-indent: 0;
  margin-top: 10px;
}

h2 {
  margin-top: 20px;
  margin-bottom: 10px;
}

p {
  margin-bottom: 10px;
}
</style>
